function attachProductClickListener() {
  const products = document.querySelector(".group-products");
  if (products) {
    products.addEventListener("click", handleClick);
  }
}

function handleClick(event) {
  const anchor = event.target.closest("a[data-url]");
  if (!anchor) return;
  event.preventDefault();

  const url = anchor.getAttribute("data-url");
  const section = document.querySelector("#main-content");
  
  fetch(url)
    .then(response => response.text())
    .then(resText => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(resText, "text/html");
      const newMainContent = doc.querySelector("#main-content");
      if (newMainContent) {
        section.innerHTML = newMainContent.innerHTML;
        // Reattach the click listener after updating the content
        attachProductClickListener();
        history.pushState(null, '', url);
      } else {
        console.error("No #main-content element found in the fetched HTML.");
      }
    })
    .catch(error => {
      console.error("Error fetching new content:", error);
      // Fallback: Navigate to the URL if the fetch fails
      window.location.href = url;
  });
}

// Initial attachment
attachProductClickListener();